/**
 * Client-side feedback limits. These MUST stay in lockstep with the
 * authoritative server-side caps in
 * apps/server/src/feedback/feedback.constants.ts -- the server rejects any
 * submission that exceeds them. They are duplicated here (rather than imported)
 * because the server is a separate workspace that is not part of the web bundle,
 * and the repo has no shared package for values both sides read.
 */

const BYTES_PER_MB = 1024 * 1024;

/** Maximum decoded screenshot size the server accepts (MAX_SCREENSHOT_BYTES). */
export const MAX_SCREENSHOT_BYTES = 15 * BYTES_PER_MB;

/**
 * Maximum console-log string size the server accepts (MAX_CONSOLE_LOG_BYTES).
 * Also bounds the in-memory session buffer: buffering more than can ever be
 * transmitted is waste, so the buffer guard and the send cap are one value.
 */
export const MAX_CONSOLE_LOG_BYTES = 15 * BYTES_PER_MB;

/** Title length cap the server enforces (MAX_TITLE_LENGTH). */
export const MAX_TITLE_LENGTH = 256;

/** Description length cap the server enforces (MAX_DESCRIPTION_LENGTH). */
export const MAX_DESCRIPTION_LENGTH = 10_000;

/** Steps-to-reproduce length cap the server enforces (MAX_STEPS_LENGTH). */
export const MAX_STEPS_LENGTH = 10_000;

/** Required prefix of the screenshot data URL (PNG_DATA_URL_PREFIX). */
export const PNG_DATA_URL_PREFIX = 'data:image/png;base64,';

/** Same-origin endpoint that accepts a feedback submission. */
export const FEEDBACK_ENDPOINT = '/api/feedback';

/** Feedback categories the server accepts (ALLOWED_FEEDBACK_TYPES). */
export type FeedbackType = 'bug' | 'feedback';
